import { Inject, Injectable, InjectionToken } from '@angular/core';

import { Observable, of } from 'rxjs';

import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../base/services/betslip-messages-provider.service';
import { IPlaceBetButtonMessages } from '../../models';

export const PLACE_BUTTON_MESSAGES_PROVIDER = new InjectionToken<IPlaceButtonMessagesProvider>('PLACE_BUTTON_MESSAGES_PROVIDER');

export interface IPlaceButtonMessagesProvider {
    get messages$(): Observable<IPlaceBetButtonMessages>;
}

@Injectable()
export class PlaceButtonMessagesProviderService implements IPlaceButtonMessagesProvider {
    private standardMessages$: Observable<IPlaceBetButtonMessages>;

    constructor(@Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messagesProvider: IBetslipMessagesProviderService) {
        const { common } = messagesProvider.getMessages();

        const standardMessages: IPlaceBetButtonMessages = {
            loginToBet: common.LoginToBet,
            makeADeposit: common.MakeADeposit,
            depositAndPlaceBet: common.DepositAndPlaceBet,
            acceptChanges: common.AcceptChanges,
            acceptAndPlaceBet: common.AcceptAndPlaceBet,
            placeProcessing: common.PlaceProcessing,
            placeBet: common.Conclude,
            lockedBetsToRemove: common.LockedBetsToRemove,
            depositProcessing: common.DepositProcessing,
            depositAndBetProcessing: common.DepositAndBetProcessing,
            placeFreeBet: common.ConcludeFreeBet,
            acceptAndPlaceFreeBet: common.AcceptAndPlaceFreeBet,
            confirm: common.Confirm,
            RemoveSuspendedLegsToPlaceBet: common.RemoveSuspendedLegsToPlaceBet,
            updateMinStake: common.UpdateMinStake,
            updateMinStakes: common.UpdateMinStakes,
        };

        this.standardMessages$ = of(standardMessages);
    }

    get messages$(): Observable<IPlaceBetButtonMessages> {
        return this.standardMessages$;
    }
}
